import React from 'react';

// Styl A1: jeden granatowy przycisk (.pub-btn). Prop `gradient` zostaje dla zgodności, nie zmienia wyglądu.
// eslint-disable-next-line no-unused-vars
const GradientButton = ({ children, onClick, disabled = false, gradient, className = '', ...props }) => (
  <button
    type="button"
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
    className={`pub-btn ${className}`.trim()}
    {...props}
  >
    {children}
  </button>
);

export default GradientButton;
